// extracted by mini-css-extract-plugin
module.exports = {"container":"logo-module--container--2ePwd","position":"logo-module--position--1AX3V","logo":"logo-module--logo--RSQ2K"};